import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import Header from './components/headers'
import Footer from './components/footer'
import Register from './components/auth/register'
import Login from './components/auth/login'
import Logout from './components/auth/logout';
import Single from './components/posts/single'
import Search from './components/posts/search'


const routing = (
  <Router>
  <React.StrictMode>
    <Header/>
    <Switch>
        <Route exact path='/' component={App}/>
        <Route path='/register' component={Register} />
        <Route path='/login' component={Login} />
        <Route path='/logout' component={Logout} />
        <Route path='/post/:slug' component={Single} />
        <Route path='/search' component={Search} /> 
    </Switch>
    <Footer />
  </React.StrictMode>,
  </Router>
)


ReactDOM.render(routing, document.getElementById('root'))
